<template>
    <div class="row">
        <div class="col-12">
            <div class="flex-table">
                <div class="flex-table--row">
                    <div class="flex-table--header-title flex-table--cell flex-table--cell-grow-always">
                        <h5></h5>
                    </div>
                    <div class="flex-table--header-content flex-table--cell">
                        <!-- Hide FROM UI  -->
                        <!-- <h5 class="flex-table--header-content-item">Share with contractor</h5> -->
                        <h5 class="flex-table--header-content-item">Display on job</h5>
                        <div style="width: 20px"></div>
                    </div>
                </div>
                <list-item
                    v-for="form in forms_ordered"
                    v-on:click="action(form)"
                    :key="form.id"
                    :active="form.form.type === 'custom' && !form.form.is_company_library"
                    class="flex-table--row--no-padding-y"
                >
                    <template slot="title">
                        {{form.form.name}}
                        <h6 class="" v-if="form.form.subtitle">{{ form.form.subtitle }}</h6>
                    </template>

                    <template slot="center">
						<div class="">
							<div v-if="form.form.type === 'custom' && !form.form.is_company_library" class="btn-group">
								<svg-image
									:src="'/svg/' + resource_group +'/more.svg'"
									width="20px"
									height="25px"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								></svg-image>
								<div class="dropdown-menu dropdown-menu-right">
									<svg-image
										:src="'/svg/' + resource_group + '/forms.svg'"
										width="20px"
										height="20px"
										highlight="primary"
										class="dropdown-item"
										:auto_hover="true"
										:spaced="true"
										@click="cloneFormModal(form)"
									>
										<span class="text-danger">Duplicate</span>
									</svg-image>
                                    <svg-image
										:src="'/svg/' + resource_group + '/bin.svg'"
										width="20px"
										height="20px"
										highlight="danger"
										class="dropdown-item"
										:auto_hover="true"
										:spaced="true"
										@click="deleteFormModal(form)"
									>
										<span class="text-danger">Delete</span>
									</svg-image>
								</div>
							</div>
						</div>
                        <!-- Hide FROM UI  -->
                        <!-- <div class="flex-table--header-content-item">
                            <label class="toggle">
                                <input type="checkbox" v-bind:checked="form.pc_access" v-on:click="togglePcAccess(form, $event)">
                                <span class="toggle--slider"></span>
                            </label>
                        </div> -->
                        <div class="flex-table--header-content-item">
                            <label class="toggle ml-2">
                                <input type="checkbox" v-bind:checked="form.active" v-on:click="toggleEnabled(form, $event)">
                                <span class="toggle--slider"></span>
                            </label>
                        </div>
                    </template>
                </list-item>
                <h6 class="my-2" v-if="!forms.length">No forms found</h6>
            </div>
        </div>
		<clone-form-modal
			ref="clone_modal"
			:clone_url="clone_url"
		></clone-form-modal>

        <delete-form-modal
            ref="delete_modal"
            :delete_url="delete_url"
        ></delete-form-modal>
    </div>
</template>

<script>
    import ListItem from "../ListComponent/ListItem";
	import CloneFormModal from "../modals/CloneFormModal";
    import DeleteFormModal from '../modals/DeleteFormModal';
    export default {
        name: "JobFormsPage",
        components: {CloneFormModal, DeleteFormModal, ListItem},

        props: {
            forms: {
                type: Array,
                required: true
            },

            edit_url: {
                type: String,
                required: true
            },

			clone_url: {
            	type: String,
				required: true
			},

            delete_url: {
                type: String,
                required: true
            },

            toggle_url: {
                type: String,
                required: true
            },
            /** Hide FROM UI */
            // toggle_pc_access_url: {
            //     type: String,
            //     required: true
            // }
        },

        methods: {
            action(form){
                window.location.href = this.edit_url.replace('?', form.id);
            },
             /** Hide FROM UI */
            // togglePcAccess(form, e){
            //     axios.patch(this.toggle_pc_access_url.replace('?', form.id), {
            //         active: e.target.checked
            //     });
            // },

            toggleEnabled(form, e){
                axios.patch(this.toggle_url.replace('?', form.id), {
                    active: e.target.checked
                });
            },

			cloneFormModal(form){
            	this.$refs.clone_modal.open(form);
			},

            deleteFormModal(form){
                var formid = form.id;
                var formname = form.form.name;
                this.$refs.delete_modal.open(formid,formname);
            }
        },

		computed: {
			forms_ordered(){
				return Object.assign([], this.forms)
					.sort((a, b) => {
						if (a.form && b.form){
							//if both a and b are the same
							if (!(a.form.is_company_library ^ b.form.is_company_library))
								return a.form.name > b.form.name ? 1 : -1;
							else
								return a.form.is_company_library ? 1 : -1;
						}

						return a.name > b.name;
					});
			}
		}
    }
</script>
